/**
 * Normalize YouTube thumbnail URLs.
 *
 * The YouTube oEmbed / video-detail API sometimes returns signed thumbnail
 * URLs of the form:
 *   https://i9.ytimg.com/vi_webp/{id}/mqdefault.webp?v=…&sqp=…&rs=…
 * The `sqp` / `rs` params are short-lived tokens — once they expire the URL
 * returns 404, logging noise to the console.
 *
 * Rewrite those to the unsigned, permanent form:
 *   https://i.ytimg.com/vi/{id}/mqdefault.jpg
 * All other URLs (Cloudflare Stream, Supabase Storage, local paths) pass
 * through untouched.
 */
export function normalizeThumbnailUrl(url?: string | null): string | null {
  if (!url) return url ?? null;
  if (!/ytimg\.com/.test(url)) return url;
  const m = url.match(/\/vi(?:_webp)?\/([A-Za-z0-9_-]{11})\//);
  if (!m) return url;
  return `https://i.ytimg.com/vi/${m[1]}/mqdefault.jpg`;
}
